(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/tournament-registration-form/assets/javascripts/tournament-select.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/tournament-registration-form/assets/javascripts/tournament-select.js');
"use strict";

const _svs$ui$reactForm = svs.ui.reactForm,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Select = _svs$ui$reactForm.Select,
  Option = _svs$ui$reactForm.Option;
const TournamentSelect = _ref => {
  let id = _ref.id,
    label = _ref.label,
    onChange = _ref.onChange,
    options = _ref.options,
    value = _ref.value;
  return React.createElement(ControlGroup, {
    className: "col-xs-12 col-md-6",
    v2: true
  }, React.createElement(Select, {
    id: id,
    inverted: true,
    label: label,
    onChange: onChange,
    v2: true,
    value: value
  }, options.map(_ref2 => {
    let id = _ref2.id,
      title = _ref2.title;
    return React.createElement(Option, {
      key: id,
      value: id
    }, title);
  })));
};
setGlobal('svs.poker_react.components.tournamentRegistrationForm.TournamentSelect', TournamentSelect);

 })(window);